import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import vuetify from "./plugins/vuetify";
import VueGeolocation from 'vue-browser-geolocation'
import * as  VueGoogleMaps from 'vue2-google-maps'
import "@/assets/styles/master.css";
import "@/assets/styles/fontawesome.min.css";
import "@/assets/styles/vuetify.css";
import "@/assets/styles/all.min.css";
import "@/assets/styles/bootstrap.min.css";
import moment from "moment-jalaali";
import goTo from 'vuetify/lib/services/goto';
import VuePreferences, {preference} from 'vue-preferences'
import VuePageTransition from 'vue-page-transition'
import VueAddtohomescreen from "@owliehq/vue-addtohomescreen";
import VueSilentbox from 'vue-silentbox'
import store from "./store";
import VueMeta from 'vue-meta';
import "@/assets/styles/materialdesignicons.min.css";
import ZoomOnHover from "vue-zoom-on-hover";


Vue.use(VuePreferences, {
    storage: window.localStorage,
    namespace: 'academy'
});
Vue.use(VueAddtohomescreen);
Vue.use(ZoomOnHover);
Vue.use(VuePageTransition)
Vue.use(VueSilentbox)
Vue.use(VueMeta);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCDfnJg1u4elSPk5-bFPHlKvF62D3YdgtU',
        libraries: 'places',
        language: 'fa'
    }
});
Vue.use(VueGeolocation)

Vue.prototype.$setUserData = function (mobile, activeCode, token, role) {
    preference('userData', {defaultValue: '{"mobile":"", "activeCode":"","token":"","role":""}'})
        .set(JSON.stringify({'mobile': mobile, 'activeCode': activeCode, 'token': token, 'role': role}));
};
Vue.prototype.$getUserData = function () {
    return JSON.parse(preference('userData',
        {defaultValue: '{"mobile":"", "activeCode":"","token":"","role":""}'}).get());
};


Vue.prototype.$moment = function (date) {
    return moment(date).format('jYYYY/jM/jD');
};
Vue.config.productionTip = false;

Vue.prototype.$baseUrl = "https://pwa.amoozeshamlak.com";
/*Vue.prototype.$baseUrl = "https://localhost:44324";*/
Vue.prototype.$replaceHttps = function (httpUrl) {

    // return require("./assets/img/" + httpUrl);
    if (httpUrl !== null) {
        return httpUrl.replace('http://', 'https://');
    }
};

Vue.prototype.$typePages = [
    {
        id: 1,
        name: 'درباره ما'
    },
    {
        id: 2,
        name: 'تماس با ما'
    },
    {
        id: 3,
        name: 'قوانین و مقررات'
    }
]

Vue.prototype.$openLink = function (url) {
    /*var newWindow = window.open("about:blank", "_blank");
    newWindow.location = url;*/
    if (url !== null) {
        let a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.target = '_blank'
        // a.download = <your_fileName>;
        a.click();
        document.body.removeChild(a);
    }
}

Vue.prototype.$specificPageItems = [
    {
        id: 1,
        name: 'مشاوره خصوصی'
    },
    {
        id: 2,
        name: 'فرانچایز'
    },
    {
        id: 3,
        name: 'برگزاری همایش'
    },
    {
        id: 4,
        name: 'برگزاری ورکشاپ در شهر شما'
    },
    {
        id: 5,
        name: 'دریافت نمایندگی'
    },
    {
        id: 6,
        name: 'ساخت آژانس املاک'
    },
    {
        id: 7,
        name: 'صدور مدارک فنی حرفه ای و بین المللی'
    },
    {
        id: 8,
        name: 'خدمات حقوقی مسکن و املاک'
    },
    {
        id: 9,
        name: 'هوشمندسازی فایلینگ املاک'
    },
    {
        id: 10,
        name: 'ساخت اپلیکیشن املاک'
    },
    {
        id: 11,
        name: 'ایران زیلو'
    },
    {
        id: 12,
        name: 'اعضای باشگاه ایران زیلو'
    },
    {
        id: 13,
        name: 'صفحه مدارک و تحصیلات'
    },
    {
        id: 14,
        name: 'صفحه نمونه مدارک'
    },
];

Vue.prototype.$TypeProduct = [
    {
        id: 0,
        name: 'دیجیتال'
    },
    {
        id: 1,
        name: 'فیزیکی'
    }
]

Vue.prototype.$TypeDiscount = [
    {
        id: 1,
        name: 'عمومی'
    },
    {
        id: 2,
        name: 'خصوصی'
    }
]

Vue.prototype.$TypeVisitedItem = [
    {
        id: 1,
        name: 'رویداد'
    },
    {
        id: 2,
        name: 'خبر'
    },
    {
        id: 3,
        name: 'مقاله'
    },
]

Vue.prototype.$TypeSearchResult = [
    {
        id: 1,
        name: 'محصول'
    },
    {
        id: 2,
        name: 'خبر'
    },
    {
        id: 3,
        name: 'رویداد'
    },
    {
        id: 4,
        name: 'مقاله'
    },
]
Vue.prototype.$TypePayment = [
    {
        id: 1,
        name: 'آنلاین'
    },
    {
        id: 2,
        name: 'توسط ادمین'
    },
    {
        id: 3,
        name: 'آفلاین'
    },
]
Vue.prototype.$TypeInvoiceStatus = [
    {
        id: 1,
        name: 'ثبت سفارش'
    },
    {
        id: 2,
        name: 'تایید سفارش'
    },
    {
        id: 3,
        name: 'پرداخت سفارش'
    },
    {
        id: 4,
        name: 'در حال ارسال'
    },
    {
        id: 5,
        name: 'اتمام سفارش'
    },
    {
        id: 6,
        name: 'لغو سفارش'
    },
]

Vue.prototype.$randomCodeGenerator = function (length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

Vue.prototype.$computingPriceOffer = function (price, off) {
    let priceNum = price;

    if (typeof priceNum !== "number") {
        priceNum = price.replace(",", "");
    }
    return this.$numberWithCommas(parseInt(priceNum) - (parseInt(priceNum) * (off / 100)));
};


Vue.prototype.$computingTotalPrice = function (price, count) {
    let priceNum = price;

    if (typeof priceNum !== "number") {
        priceNum = price.replace(/,/g, "");
    }
    return this.$numberWithCommas(parseInt(priceNum) * count);
};


Vue.prototype.$numberWithCommas = function (x) {
    if (x !== null) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
};

Vue.prototype.$convertFarsiNumber = function () {
    let els = document.getElementsByTagName('input');
    for (let i = 0; i < els.length; i++) {
        els[i].addEventListener("keyup", (event) => {
            if (/([۰-۹])/g.test(event.target.value)) {
                event.target.value = event.target.value.replace(/([۰-۹])/g, token => String.fromCharCode(token.charCodeAt(0) - 1728))
            }
        });
    }
}
Vue.prototype.$scrollTop = function (x) {
    x = x === undefined ? 0 : x;
    return goTo(x);
}
Vue.prototype.$convertDate = function (date) {
    let sliceDate = date.slice(0, 10)
    return moment(sliceDate).format('jYYYY/jMM/jDD')
}


Vue.prototype.$seoUrl = "https://www.amoozeshamlak.com";
Vue.prototype.$keywords = 'آکادمی کاشانی کیا, افزایش سطح علمی مشاورین املاک, افزایش سطح علمی صنف املاک, دلالان بازار املاک';

Vue.prototype.$description = 'هدف آکادمی کاشانی کیا ارتقا و افزایش سطح علمی مشاورین املاک و صاحبان آژانسهای املاک در زمینه مبانی دلالی علمی املاک و پیادهسازی سیستم مدیریت کیفیت در سراسر ایران بوده. آکادمی کاشانی کیا دارای مجوز رسمی نشر دیجیتال سرآمد از وزارت فرهنگ و ارشاد اسلامی بوده و فعالیتهای ما در راستای فرهنگسازی و افزایش سطح علمی صنف املاک و دلالان بازار املاک است';
Vue.prototype.$defaultImage = "https://www.amoozeshamlak.com/img/icons/android-chrome-maskable-512x512.png"

Vue.config.productionTip = false


new Vue({
    router,
    vuetify,
    store,
    render: h => h(App)
}).$mount('#app')


